import { z } from 'zod'

import { nullableNumber } from '../../utils/schema'

type OneShopMessageStats = z.infer<typeof oneshopMessageStatsSchema>
type OneShopMessageStatsData = z.infer<typeof messageStatsDataSchema>
const messageStatsSchema = z.object({
  count: z.number(),
  dateQueuedAverageSeconds: nullableNumber,
  dateQueuedMinSeconds: nullableNumber,
  dateQueuedMaxSeconds: nullableNumber,
  queuedSentAverageSeconds: nullableNumber,
  queuedSentMinSeconds: nullableNumber,
  queuedSentMaxSeconds: nullableNumber,
  dateSentAverageSeconds: nullableNumber,
  dateSentMinSeconds: nullableNumber,
  dateSentMaxSeconds: nullableNumber,
})

const messageStatsTypeSchema = z.object({
  canceled: messageStatsSchema,
  pending: messageStatsSchema,
  accepted: messageStatsSchema,
  queued: messageStatsSchema,
  sending: messageStatsSchema,
  sent: messageStatsSchema,
  delivered: messageStatsSchema,
  undelivered: messageStatsSchema,
  failed: messageStatsSchema,
})

const messageStatsDataSchema = messageStatsSchema.extend({
  type: z.string(),
  status: z.string(),
})

const oneshopMessageStatsSchema = z.object({
  email: messageStatsTypeSchema,
  sms: messageStatsTypeSchema,
  data: z.array(messageStatsDataSchema),
})

export type { OneShopMessageStats, OneShopMessageStatsData }

export { oneshopMessageStatsSchema }
